import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// accounts routing
const Accounts = Loadable(lazy(() => import('views/accounts')));
const AccountInfo = Loadable(lazy(() => import('views/accounts/account-info/AccountInfoPage')));

// devices routing
const Devices = Loadable(lazy(() => import('views/devices')));
const DeviceInfo = Loadable(lazy(() => import('views/devices/device-info/DeviceInfoPage')));

// User settings routing
const UserSettings = Loadable(lazy(() => import('views/users/settings')));
const PermissionList = Loadable(lazy(() => import('views/users/permissions')));

// Guardian settings routing
const GuardianOAuthSettings = Loadable(lazy(() => import('views/settings/oauth')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    // Guardian project routing starts here - do not remove or modify this line
    // accounts routing
    {
      path: '/accounts',
      element: <Accounts />
    },
    {
      path: '/accounts/account-info',
      element: <AccountInfo />
    },
    // devices routing
    {
      path: '/devices',
      element: <Devices />
    },
    {
      path: '/devices/device-info',
      element: <DeviceInfo />
    },
    // User profile routing
    {
      path: '/user/settings',
      element: <UserSettings />
    },
    {
      path: '/permission/list',
      element: <PermissionList />
    },
    // Guardian settings routing
    {
      path: '/settings/oauth',
      element: <GuardianOAuthSettings />
    }
  ]
};

export default MainRoutes;
